import { Constant } from "../../config";
import axios from "axios";

export default {
  getGatwayCountryLogsLists: async (page = 1, limit = 10, search = "") => {
    const url =
      Constant.GATEWAY_COUNTRY_LOGS_API +
      "?page=" +
      page +
      "&limit=" +
      limit +
      "&search=" +
      search;
    const opt = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    const d = resp.data.data;

    const output = {
      totalRows: resp.data.total_rows || 0,
      dataSource: d,
    };

    return output;
  },
  getAdminLists: async () => {
    let url = Constant.ADMIN_GETALL_API;

    let opt = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    const arrayAdminIds = [];
    for (const admin of resp.data.data) {
      arrayAdminIds.push(admin["id"]);
    }

    return { list: resp.data.data, adminIds: arrayAdminIds };
  },
};



// WEBPACK FOOTER //
// ./src/containers/GatewayCountryLogs/services.js